import { render, staticRenderFns } from "./Direktbevorratung.vue?vue&type=template&id=45fd4061&"
import script from "./Direktbevorratung.vue?vue&type=script&lang=js&"
export * from "./Direktbevorratung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports